import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "./../../../assets/images/Service-Me-Final-Logo-5.png";
import "./Navbar.scss";

export default function Navbar() {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    if (isMenuOpen) setIsMenuOpen(false);
  }, [location]);

  return (
    <div className="md:px-2 text-sm">
      <nav
        className={`w-full shadow max-w-6xl p-2 py-1 mx-auto h-16 bg-white md:rounded-b-md dark:bg-gray-800 my-auto`}
      >
        <div className="max-w-screen-2xl flex flex-row-reverse flex-wrap items-center justify-between mx-auto py-2 px-4 ">
          <Link
            to={"/"}
            className="flex items-center space-x-3 rtl:space-x-reverse"
          >
            <img className="w-32 drop-shadow-lg" src={logo} alt="" />
          </Link>

          <div className="flex flex-row-reverse gap-1">
            {location.pathname !== "/" && location.pathname !== "/login" && (
              <Link
                to="/login"
                className="block py-2 px-3 text-mainDark dark:text-mainLight font-bold"
              >
                تسجيل دخول
              </Link>
            )}
          </div>
        </div>
      </nav>
    </div>
  );
}
